<div class="captcha-container">
  <!-- Checkbox Shell -->
  <div class="captcha-box" (click)="toggleCheck()" [class.error]="isFailed">
    <div class="checkbox-container">
      <!-- Spinner Wrapper (Handles Scale) -->
      <div class="spinner-wrapper" [class.visible-scale]="isCheckboxLoading">
        <!-- Spinner Inner (Handles Spin) -->
        <div class="spinner-loader"></div>
      </div>
      
      <!-- Checkbox -->
      <div class="checkbox" [class.error]="isFailed" [class.checked]="isChecked" [class.hidden-scale]="isCheckboxLoading">
        <div class="checkmark" *ngIf="isChecked && !isCheckboxLoading && !isFailed"></div>
        <div class="error-x" *ngIf="isFailed"></div>
      </div>
    </div>
    <div class="label-wrapper">
      <div class="label">I'm not a robot</div>
      <div class="error-text" *ngIf="isFailed">Captcha failed, please try again</div>
    </div>
    <div class="logo">
      <img src="/img/captcha/logo.png" alt="reCAPTCHA logo">
      <div class="terms">jCAPTCHA</div>
      <div class="links">Privacy - Terms</div>
    </div>
  </div>

  <!-- Challenge Modal -->
  <div class="challenge-modal" *ngIf="isModalOpen">
    <div class="modal-content">
      <div class="header">
        <div class="header-text">
          <span class="title">Select all images with</span>
          <span class="keyword">{{ challengeWord }}</span>
          <div class="instruction">Click continue once there are none left.</div>
        </div>
      </div>
      
      <div class="image-grid">
        <div 
          class="grid-item" 
          *ngFor="let img of images"
          (click)="onImageClick(img)"
        >
          <div class="img-wrapper">
             <img 
               [src]="img.url" 
               [class.fading-out]="img.isFadingOut"
               [class.fading-in]="img.isFadingIn"
               [style.opacity]="img.visible ? 1 : 0"
               [style.transition-duration.s]="fadeDuration"
               [style.animation-duration.s]="fadeDuration"
               alt="Challenge Image"
             >
          </div>
        </div>
      </div>

      <div class="footer">
        <div class="footer-icons">
          <button class="icon-btn reload" (click)="resetChallenge()" title="Get a new challenge"></button>
          <button class="icon-btn info" title="Help"></button>
        </div>
        <button class="verify-btn" (click)="onContinue()" [disabled]="isVerifying">
           <span *ngIf="!isVerifying">CONTINUE</span>
           <div class="btn-spinner" *ngIf="isVerifying"></div>
        </button>
      </div>
    </div>
  </div>
</div>
